import { Link, NavLink } from 'react-router-dom'
import { useState } from 'react'
import ThemeToggle from './ThemeToggle'

const navItemClass = ({ isActive }) =>
  'px-3 py-2 rounded-xl transition ' +
  (isActive
    ? 'bg-secondary/10 text-secondary dark:bg-white/10 dark:text-white'
    : 'text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-white/5')

export default function Navbar() {
  const [open, setOpen] = useState(false)
  const [prodOpen, setProdOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50">
      <div className="nav-glass">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-3">
            <Link to="/" className="flex items-center gap-3">
              <img alt="The Daybook" src="/hook2.svg" className="w-8 h-8" />
              <span className="text-xl font-semibold tracking-tight">The Daybook</span>
            </Link>

            <nav className="hidden md:flex items-center gap-1">
              <NavLink to="/" className={navItemClass} end>Home</NavLink>
              <NavLink to="/about" className={navItemClass}>About</NavLink>
              {/* <NavLink to="/contact">Daybook</NavLink> */}
              <NavLink to="/contact" className={navItemClass}>Request a Demo</NavLink>
              <div className="ml-2"><ThemeToggle /></div>
            </nav>

            <div className="md:hidden flex items-center gap-2">
              <ThemeToggle />
              <button
                className="px-3 py-2 rounded-xl hover:bg-slate-100 dark:hover:bg-white/5"
                onClick={() => setOpen(o => !o)}
                aria-label="Toggle navigation"
              >
                ☰
              </button>
            </div>
          </div>
        </div>

        {open && (
          <div className="md:hidden border-t border-slate-200 dark:border-white/10">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-3 space-y-2">
              <NavLink to="/" className={navItemClass} end onClick={() => setOpen(false)}>Home</NavLink>
              <NavLink to="/about" className={navItemClass} onClick={() => setOpen(false)}>About</NavLink>
              {/*<NavLink to="/daybook" className={navItemClass} onClick={() => setOpen(false)}>Daybook</NavLink>*/}
              <NavLink to="/contact" className={navItemClass} onClick={() => setOpen(false)}>Request a Demo</NavLink>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}
